import { RefObject, useImperativeHandle } from 'react';
import { SelectMenuHandle } from './types';

/**
 * Hook that attaches the `scrollToGroup` and `scrollToOption` imperative
 * handlers to the root component ref.
 * @param openMenu function that opens the select menu
 * @param optionsRef ref for the options component
 * @param ref ref for the root component
 */
export const useSelectMenuHandle = (
  openMenu: () => void,
  optionsRef?: RefObject<SelectMenuHandle>,
  ref?: RefObject<SelectMenuHandle>,
) => {
  // implement scrollTo handlers
  useImperativeHandle(ref, () => ({
    scrollToGroup: group => {
      // open menu and scroll to the group
      openMenu();
      // raf to ensure select is open
      requestAnimationFrame(() => {
        optionsRef?.current?.scrollToGroup(group);
      });
    },
    scrollToOption: key => {
      // open menu and scroll to the option
      openMenu();
      // raf to ensure select is open
      requestAnimationFrame(() => {
        optionsRef?.current?.scrollToOption(key);
      });
    },
  }));
};
